import React, {Component} from "react";
import AppActions from "../flux/AppActions";
import Toast from "../toast";
import AjaxLoader from "../components/AjaxLoader";
import EventsList from "../components/EventsList";

const locale = (typeof (window.AppWizardLocale) !== 'undefined' ? window.AppWizardLocale : false);
if (!locale) {
    throw new Error('Error: Locale not loaded');
}

const $ = window.jQuery;
const toast = new Toast();

class PageEvents extends Component {
    constructor(props) {
        super(props);

        this.inputRef = React.createRef();

        this.state = props.app.state;

        this.__getEvents = this.__getEvents.bind(this);
        this.__onEventClick = this.__onEventClick.bind(this);
    }

    componentDidMount() {
        AppActions.updatePage('events');
        this.__getEvents(this.props);
    }

    __getEvents(props) {
        window.scrollTo({
            top: 0
        });

        this.setState({
            loading: true,
            campaigns: []
        });

        let locale = props.locale;
        let {ajaxurl, nonce_name, nonce_value} = locale;
        let self = this;
        let ajaxConfig = {
            url: ajaxurl,
            method: "POST",
            timeout: 29000,
            cache: false,
            async: true,
            data: {
                action: "bth_ajax",
                request: "get_events",
                campaign: props.app.props.campaign,
                [nonce_name]: nonce_value
            }
        };

        $.ajax(ajaxConfig)
            .done(function (r) {
                if (r) {
                    if (r.success) {
                        if (r.data) {
                            self.setState({
                                page_data: r.data.items,
                                loading: false
                            });
                        } else {
                            toast.show(locale.texts.empty_response, Toast.TYPE_ERROR);
                        }
                    } else {
                        if (r.data) {
                            toast.show(r.data, Toast.TYPE_ERROR);
                        } else {
                            toast.show(locale.texts.empty_response, Toast.TYPE_ERROR);
                        }
                    }
                } else {
                    toast.show(locale.texts.no_response, Toast.TYPE_ERROR);
                }
            })
            .fail(function (x, s, e) {
                toast.show(e, Toast.TYPE_ERROR);
            })
            .always(function () {
                self.setState({
                    loading: false
                });
            });
    }

    __onEventClick(eventId) {
        // let event = this.state.page_data.find(event => event.id === eventId);
        // AppActions.updateStore( {
        //     event: event,
        //     page: 'brands',
        // } );

        let event = this.state.page_data.find(event => event.id === eventId);
        AppActions.updateStore({
            event: event,
            page: 'cocktails',
        });
    }

    render() {
        let locale = this.props.locale;
        let page_data = (this.state.page_data.length ? this.state.page_data : false);

        return (
            <React.Fragment>
                <header className="header header--content-pages">
                    <div className="header__text header__text--clipped">
                        <h1 className="header__text-title">ALEGE-ȚI EXPERIENȚA</h1>
                    </div>
                </header>
                {this.state.loading ? <AjaxLoader/> :
                    <EventsList locale={locale} items={page_data} onItemClick={this.props.onEventClick}/>
                }
            </React.Fragment>
        );
    }
}

export default PageEvents;
